import React from "react";
import { Respuestas } from "./Respuestas";
import { Box, Stack, Typography } from "@mui/material";
import { CuestionContext } from "../context/CuestionContext";
import { useContext } from "react";
import Parser from 'html-react-parser';
import "../styles/MisCuestionarios.css"
import colors from "../theme/colors"

export function Preguntas({ pregunta }) {
  const { t } = useContext(CuestionContext)

  return (
    <>
        <Stack spacing={4}>
          <Stack direction={"row"} spacing={2}>
                  <Typography variant="h3" color={colors.bgPrimary} sx={{ fontWeight: 'bold' }}>
              {pregunta.texto && Parser(pregunta.texto)}
            </Typography>
          </Stack>
          <Respuestas loading/>
        </Stack>
    </>
  );
}
